import { gql } from "@apollo/client";

export const AssetsTotal = gql`
  query AssetsTotal($filter: SearchAssetFilter) {
    searchAssets(filter: $filter) {
      total
    }
  }
`;
